import React, { useEffect, useState } from 'react';
import './CSS/About.css';
import aboutBanner from '../assets/images/about-banner.png';
import aboutBanner1 from '../assets/images/about-banner1.png';

const AboutHero = () => {

    const [backgroundImage, setBackgroundImage] = useState(aboutBanner);

    useEffect(() => {
        const updateBackground = () => {
            if (window.innerWidth < 768) {
                setBackgroundImage(aboutBanner1);
            } else {
                setBackgroundImage(aboutBanner);
            }
        };

        updateBackground(); // Run once on mount
        window.addEventListener('resize', updateBackground);

        return () => window.removeEventListener('resize', updateBackground);
    }, []);

    return (
        <section
            className="about-hero-section"
            style={{ backgroundImage: `url(${backgroundImage})` }}
        >
            <div className="container">
                <div className="about-hero-content">
                    <div className="hero-tag">
                        About Us
                    </div>
                    <h1 className="about-hero-title">
                        <span className="text-primary">We're fixINN</span> — Your Local Solution For Fast, Reliable Services.
                    </h1>
                    <p className="about-hero-subtitle">
                        fixINN is your go-to solution for reliable, local services — from tech repairs to personal coaching. Rooted in Notting Hill, we exist to simplify your everyday fixes.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default AboutHero;
